import EventEmitter from 'event-emitter';

const TYPE = {
  TOGGLE_DRAWER: '@event/TOGGLE_DRAWER',
  SHOW_NOTIFICATION: '@event/SHOW_NOTIFICATION',
  DOWNLOAD_PROGRESS: '@event/DOWNLOAD_PROGRESS',
};

class EventService {
  public EVENT = TYPE;
  private emitter = EventEmitter();

  emit(eventName: string, ...args: any[]): void {
    this.emitter.emit(eventName, ...args);
  }

  addListener(eventName: string, fn: (...args: any[]) => void): void {
    this.emitter.on(eventName, fn);
  }

  removeListener(eventName: string, fn: (...args: any[]) => void): void {
    this.emitter.off(eventName, fn);
  }
}

export default new EventService();
